module.exports = __webpack_public_path__ + "static/portuguese-bank-account-setup-339fb4e5cfccca5b068933e27f50b96b.svg";